import Modal from 'react-modal';
import './CommonModal.scss';

const CommonModal = ({ children, isModalOpen, closeModal, className, title, noHeader }) => {
  return (
    <Modal
      isOpen={isModalOpen}
      className={className}
      ariaHideApp={false}
    >
      {
        !noHeader &&
        <div className='modal-header'>
          <div className='title'>{title}</div>
          <div
            className='close'
            onClick={closeModal}
          />
        </div>
      }
      <div className='modal-body'>{children}</div>
      
    </Modal>
  );
}

CommonModal.defaultProps = {
  noHeader: false,
}

export default CommonModal;
